export default __webpack_public_path__ + "static/media/cardfronten.c59f0eb9.png";